import { convertEntities } from '../../utils/helpers';
import Icon from '../icon';

function RetailerCardLarge( { data, showLogos, hideAddressField, hidePhoneField, hideWebsiteField } ) {
	const { distance, content: {
		title,
		website,
		phone,
		logo,
	}, id, address } = data;

	const distanceFigure = (
		<figure className="retailer__figure-distance">
			<h2 className="retailer-location__distance">{ distance }km</h2>
		</figure>
	);

	const logoFigure = (
		<figure className="retailer__figure">
			<span className="retailer__logo"><img decoding="async" src={ logo } alt="Retailer logo" /></span>
		</figure>
	);

	return (
		<article id={ `post-${ id }` } className="retailer">
			{ showLogos ? logoFigure : distanceFigure }
			<div className="retailer__content">
				<h3 className="retailer__heading">{ convertEntities( title ) }</h3>
				<ul className="retailer__data">
					{ address && ! hideAddressField && ( <li className="retailer__data-item"><Icon name="map-pin" />{ address }</li> ) }
					{ phone && ! hidePhoneField && ( <li className="retailer__data-item"><Icon name="phone" /><a
						href={ `tel:${ phone }` }>{ phone }</a></li> ) }
					{ website && ! hideWebsiteField && ( <li className="retailer__data-item"><Icon name="globe" /><a
						href={ `https:\/\/${ website }` } target="_blank" rel="noopener noreferrer">{ website }</a></li> ) }
				</ul>
			</div>
		</article>
	);
}

export default RetailerCardLarge;
